export default __webpack_public_path__ + "static/media/art-embed.5c9648d9.jpg";